const style = {
  fontFamily: "Pretendard",
  fontSize: 22,
  fontWeight: 700
};

export function AnimeItemTitle(props) {
  return (<>
    <span style={ style }>{ props.text }</span>
  </>);
}
